import React from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import UrgencyStrip from "../components/UrgencyStrip";
import TrustSection from "../components/TrustSection";
import Services from "../components/Services";
import CentroAutomotivo from "../components/CentroAutomotivo";
import WhyUs from "../components/WhyUs";
import AreasAtendidas from "../components/AreasAtendidas";
import InstagramSection from "../components/InstagramSection";
import Testimonials from "../components/Testimonials";
import FAQ from "../components/FAQ";
import Footer from "../components/Footer";
import { FloatingWhatsApp, MobileCallBar } from "../components/FloatingCTAs";

export default function Landing() {
  return (
    <main data-testid="landing-page" className="bg-[#0A0A0A] text-white min-h-screen">
      <Header />
      <Hero />
      <UrgencyStrip />
      <TrustSection />
      <Services />
      <CentroAutomotivo />
      <WhyUs />
      <AreasAtendidas />
      <InstagramSection />
      <Testimonials />
      <FAQ />
      <Footer />
      <FloatingWhatsApp />
      <MobileCallBar />
    </main>
  );
}
